const getters = {
    sidebar: (state) => state.app.sidebar,
    size: (state) => state.app.size,
    device: (state) => state.app.device,
    dict: (state) => state.dict.dict,
    visitedViews: (state) => state.tagsView.visitedViews,
    cachedViews: (state) => state.tagsView.cachedViews,
    parentUserId: (state) => state.user.parentUserId,
    introduction: (state) => state.user.introduction,
    roles: (state) => state.user.roles,
    permissions: (state) => state.user.permissions,
    permission_routes: (state) => state.permission.routes,
    topBarRouters: (state) => state.permission.topBarRouters,
    defaultRoutes: (state) => state.permission.defaultRoutes,
    sidebarRouters: (state) => state.permission.sidebarRouters,
    guide: (state) => state.user.guide,
    access: (state) => state.user.access,

    token: (state) => state.user.token,
    name: (state) => state.user.name,
    avatar: (state) => state.user.avatar,
    instanceId: (state) => state.user.instanceId,
};
export default getters;
